import { createRouter, createWebHistory } from 'vue-router'

// Lazy load components for better code splitting and performance
// const HomeView = () => import(/* webpackChunkName: "home" */ '@/views/HomeView.vue')
const ProcessedCsv = () => import(/* webpackChunkName: "processed" */ '@/views/ProcessedCsv')
const PdfsProcessed = () => import(/* webpackChunkName: "pdfs" */ '@/views/PdfsProcessed')
const ClaudeProcessed = () => import(/* webpackChunkName: "claude" */ '@/views/ClaudeProcessed')
const LoginView = () => import(/* webpackChunkName: "login" */ '@/public/LoginView')
const ProcessPdf = () => import(/* webpackChunkName: "process" */ '@/views/ProcessPdf')
const ContactsView = () => import(/* webpackChunkName: "contacts" */ '@/views/ContactsView')
const DbOptions = () => import(/* webpackChunkName: "dboptions" */ '@/views/DbOptions')
const SettingsView = () => import(/* webpackChunkName: "settings" */ '@/views/SettingsView')
const DashboardView = () => import('@/views/DashboardView')
const ConfigurationView = () => import ('@/views/ConfigurationView')

const routes = [
  {
    path: '/config',
    name: 'configuration',
    component: ConfigurationView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dboptions',
    name: 'dboptions',
    component: DbOptions,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/process',
    name: 'processpdf',
    component: ProcessPdf,
    meta: { requiresAuth: true }
  },
  {
    path: '/claude',
    name: 'claudeprocessed',
    component: ClaudeProcessed,
    meta: { requiresAuth: true }
  },
  {
    path: '/pdfsprocessed',
    name: 'pdfsprocessed',
    component: PdfsProcessed,
    meta: { requiresAuth: true }
  },
  {
    path: '/processed',
    name: 'processed',
    component: ProcessedCsv,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'home',
    component: LoginView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  console.log('router hook', to.path, 'from', from.path)
  next()
});

export default router
